import { render, staticRenderFns } from "./ot-button-dropdown-wrapper.vue?vue&type=template&id=72f4986f&scoped=true&"
import script from "./ot-button-dropdown-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-button-dropdown-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-button-dropdown-wrapper.vue?vue&type=style&index=0&id=72f4986f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f4986f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VMenu})
